
















import { Component, Vue } from 'vue-property-decorator';
import { saveTempleteType } from '@/apis/course/course';
import i18n from '@/lang';

@Component({})
export default class chooseCourseModule extends Vue {
  readonly typeList = [i18n.t('Home.混合课程'), i18n.t('Home.线下课程'), i18n.t('Home.在线课程'), i18n.t('Home.实验课'), i18n.t('Home.社会实践课'), i18n.t('Home.其他')];
  private activeName: string = '1';

  get newCourseId() {
    return this.$store.state.newCourseId;
  }

  created() {
    this.$setNavInfo({
      title: i18n.t('Home.选择课程模板') as string
    });
    if(!this.newCourseId) {
      this.ktpCourse();
    }
  }

  ktpCourse() {
    this.$router.push('/ktpCourse');
  }

  submit() {
    saveTempleteType({ courseid: this.newCourseId, type: this.activeName }).then(() => {
      this.ktpCourse();
    })
  }

  beforeDestroy() {
    this.$store.state.newCourseId = '';
  }

};
